const COMPONENT_NAME = "Button";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error:`;
export {
  COMPONENT_NAME,
  INVALID_PROPS_ERROR
};
